<template>
  <div class="template">
    <div class="floating-container">
      <RouterRadioButtons :options="textOptions" />
    </div>
    <RouterView />
  </div>
</template>

<script setup>
import { RouterView, useRouter } from "vue-router";

import RouterRadioButtons from "@follaw-fr/components/reusable/molecules/RouterRadioButtons.vue";

const router = useRouter();

// Build tabs navbar options from router config
const routerOptions = router
  .getRoutes()
  .find((route) => route.name === "Alerting")
  .children.filter((route) => !!route.name);

const iconMapping = {
  "Alerting - Alertes": "fa-regular fa-bell",
  "Alerting - Récapitulatifs": "fa-regular fa-alarm-clock",
};
const textOptions = routerOptions.map((route) => {
  const iconClass = iconMapping[route.name];
  return {
    label: route.name.replace("Alerting - ", ""),
    value: `/alerting/${route.path}`,
    icon: iconClass,
  };
});
</script>

<style scoped>
p {
  margin: 0;
}
.floating-container {
  position: absolute;
}
</style>
